import { render, staticRenderFns } from "./front-stock.vue?vue&type=template&id=1ae39783"
import script from "./front-stock.vue?vue&type=script&lang=ts"
export * from "./front-stock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports